import { Card } from 'antd';
import Flex from '../Flex';

import './index.css';

export interface FeatureCardProps {
  title: any;
  icon: any;
  onClick: any;
  variant: ComponentVariant;
  disabled: boolean;
}

export function FeatureCard({
  variant,
  title,
  icon,
  onClick,
  disabled
}: FeatureCardProps) {
  return (
    <Card onClick={disabled ? undefined : onClick} className={`feature-card !bg-${variant}-extra-light !border-none`}>
      <Flex
        gap={4}
        align="center"
        direction="column"
        justify="center"
        className="feature-card-content"
        style={disabled ? { filter: 'grayscale(1)' } : undefined}
      >
        <div className="ic-container">
          {icon}
        </div>
        <span className={`feature-title text-${variant}-darker font-bold`}>{title}</span>
      </Flex>
    </Card>
  );
}

export default FeatureCard;
